import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AlertCircleIcon, CheckCircleIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'
import {useMemo} from 'react'
import {useTheme} from 'styled-components'

interface PlannedAccessesAbsenceTotalDetailsProps {
    totalAbsencesAccessesCount: number
    totalInPresenceAccessesCount: number
    selectedAbsenceThresholdPercentage: number
    showPercentage?: boolean
    showZeroValue?: boolean
    showPercentageIncidence?: boolean
}

export const PlannedAccessesAbsenceTotalDetails = ({
    totalAbsencesAccessesCount,
    totalInPresenceAccessesCount,
    selectedAbsenceThresholdPercentage,
    showPercentage,
    showZeroValue,
    showPercentageIncidence
}: PlannedAccessesAbsenceTotalDetailsProps) => {
    const {t} = useTranslation()
    const {palette} = useTheme()

    const percentageIncidence = useMemo(() => {
        if (!totalAbsencesAccessesCount || !totalInPresenceAccessesCount) return 0
        return Number(((totalAbsencesAccessesCount / totalInPresenceAccessesCount) * 100).toFixed(2))
    }, [totalAbsencesAccessesCount, totalInPresenceAccessesCount])

    return (
        <DetailsField>
            <Flexbox align="center" gap={2}>
                <Text size="textSm" weight="400" palette="neutral" shade="600">
                    {t('planned_accesses:total_absences_field_title')}
                </Text>
                {showPercentageIncidence ? (
                    Number(percentageIncidence) > selectedAbsenceThresholdPercentage ? (
                        <AlertCircleIcon size={14} color={palette.orange[500]} />
                    ) : (
                        <CheckCircleIcon size={14} color={palette.success[500]} />
                    )
                ) : null}
            </Flexbox>
            <Text size="textSm" weight="500">
                {totalAbsencesAccessesCount || (showZeroValue ? totalAbsencesAccessesCount : '-')}{' '}
                {showPercentage && (
                    <Text weight={400} render="span" palette="neutral" shade="500">
                        ({percentageIncidence ?? '-'}%)
                    </Text>
                )}
            </Text>
        </DetailsField>
    )
}
